module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"show-more":"Подробнее","hide":"Скрыть","address":"Адрес","customer":"Заказчик","performer":"Подрядчик","phone_number":"Телефон","closed_line_count":"Кол-во перекрытых полос"},"en":{"show-more":"Show more","hide":"Hide","address":"Address","customer":"Customer","performer":"Performer","phone_number":"Phone number","closed_line_count":"Closed line count"}}')
  delete Component.options._Ctor
}
